import { DTOModel } from "../../models/base/dto-model";
import { BaseApiService } from "../base";
import { STOModel } from "../../models/base/sto-model";
import { AlertLineReportNoteDTO } from "../../models/alert-line-report-note/alert-line-report-note-dto";

export class AlertLineReportNoteFileReviewApiService extends BaseApiService<AlertLineReportNoteDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/SaveAlertLineReportNoteFileReview",
      saveItemsPath: "/",
    });
  }
}
